var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-menu',{attrs:{"menu":_vm.menu}},[_c('span',{attrs:{"slot":"dropdown-icon"},slot:"dropdown-icon"},[_c('i',{staticClass:"fa fa-angle-down fa-lg",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }